import React from "react";
import { IHarvestDetailsRFAResponseModel } from "../../typings/models/HarvestDetailsRFAResponseModel";

interface GridRowProps {
  data: IHarvestDetailsRFAResponseModel;
}

const handleAmendClick = (id: string) => {};

const HarvestDetailsRFAGridRow: React.FC<GridRowProps> = ({ data }) => {
  return (
    <tr>
      <td>{data.rfaCategoryString}</td>
      <td>{data.remarks}</td>
      <td>{data.applicantRemarks}</td>
      {/* Add other data fields here */}
    </tr>
  );
};

export default HarvestDetailsRFAGridRow;
